module.exports = __webpack_public_path__ + "static/media/instacart_discount_icon.377e07b6.svg";